<template>
    <div class="body">

        <div class="search-box">
            <div>
                <span class="title">通告范围：</span>
                <el-select class="search-input" :clearable=false v-model="type" placeholder="通告范围" @change="getData"
                           @clear="">
                    <el-option class=""
                               v-for="item in announce_type"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value"
                    >
                    </el-option>
                </el-select>
            </div>
            <div>
                <span class="title">发送状态：</span>
                <el-select class="search-input margin-right-0" clearable v-model="state" placeholder="发送状态" @change="getData"
                           @clear="">
                    <el-option class=""
                               v-for="item in announce_state"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value"
                    >
                    </el-option>
                </el-select>
            </div>
            <div class='margin-left-30'>
                <el-button class="primary-btn" @click="reset()">重置</el-button>
                <el-button type="primary" style="margin-left: 16px" @click="getData()">查询</el-button>
            </div>
        </div>

        <div class="container">
            <el-button
                type="primary"
                icon="el-icon-circle-plus-outline"
                class="handle-del mr10"
                @click="handleAdd"
            >发送通告
            </el-button>

            <!--表单-->
            <div class="table-cls">
                <el-table
                    :data="tableData"
                    border
                    class="table"
                    :cell-style="{color:'#666666'}"
                    :header-cell-style="{background:'#eef1f6',color:'#333333',height:'49px',fontWeight:500}"
                >
                    <el-table-column prop="type" align="center" label="范围">
                        <template slot-scope="scope">
                            <div>
                                {{ range[scope.row.type] }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="type==1" prop="station_id" align="center" label="招生站点">
                        <template slot-scope="scope">
                            <div>
                                {{ website[scope.row.station_id] }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="type==2" prop="grade" align="center" label="年级"></el-table-column>
                    <el-table-column v-if="type==2" prop="major_id" align="center" label="专业">
                        <template slot-scope="scope">
                            <div>
                                {{ job[scope.row.major_id] }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="title" align="center" label="标题"></el-table-column>

                    <el-table-column prop="send_user" align="center" label="发送人"></el-table-column>
                    <el-table-column prop="state" align="center" label="发送状态">
                        <template slot-scope="scope">
                            <div :class="scope.row.state==2?'color-blue':scope.row.state==0?'color-green':'color-red'">
                                {{ send[scope.row.state] }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="send_time" align="center" label="发送时间"></el-table-column>
                    <el-table-column prop="org" align='center' label="所属院校" v-if="accountOrg == 1">
                        <template slot-scope="scope">
                            {{ orgHash[scope.row.org] }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="300px" align="center" fixed="right">
                        <template slot-scope="scope">
                            <el-button
                                type="primary"
                                @click="handleAnnounce(scope.$index, scope.row)"
                            >阅读详情
                            </el-button>
                            <el-button
                                type="primary"
                                @click="handleEdit(scope.$index, scope.row)"
                            >编辑
                            </el-button>
                            <el-button
                                type="danger"
                                @click="handleDelete(scope.$index, scope.row)"
                                :disabled="accountOrg != scope.row.org"
                            >删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 弹出框 -->
            <el-dialog :close-on-click-modal='false' :close-on-press-escape='false'
                title='发布通告'
                :visible.sync="academyValue"
                width="70%"
                custom-class="fontSize:16px"
                :before-close="CloseInfo"
            >
                <el-form ref="form" :model="form" :rules="this.form.type==1 ? rules1 :this.form.type==2 ? rules2 :rules"
                         label-width="96px">
                    <el-form-item label="范围：" prop="type">
                        <el-select class="search-input" clearable v-model="form.type" placeholder="通告范围"
                                   @change="issueInfo" @clear="noscope">
                            <el-option class=""
                                       v-for="item in announce_type"
                                       :key="item.value"
                                       :label="item.label"
                                       :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <!-- 1 -->
                    <el-form-item label="招生站点：" prop="station_id" v-if="range1">
                        <el-select class="search-input" v-model="form.station_id" clearable placeholder="招生站点">
                            <el-option class=""
                                       v-for="item in site"
                                       :key="item.value"
                                       :label="item.label"
                                       :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <!-- 2-->
                    <el-form-item label="年级：" prop="grade" v-if="range2">
                        <el-date-picker
                            v-model="form.grade"
                            type="year"
                            placeholder="选择年级"
                            clearable
                            format="yyyy"
                            value-format="yyyy"
                            style="margin-right: 16px;
								width: 215px !important;
								height: 30px !important;"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="专业：" prop="major_id" v-if="range2">
                        <el-select class="search-input" clearable v-model="form.major_id" placeholder="专业">
                            <el-option class=""
                                       v-for="item in career"
                                       :key="item.value"
                                       :label="item.label"
                                       :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="通告标题：" prop="title">
                        <el-input
                            type="textarea"
                            placeholder="请输入通告标题"
                            :autosize="{ minRows: 4}"

                            v-model="form.title"
                            maxlength="32"
                            show-word-limit
                            style="width: 240px"
                        >
                        </el-input>
                    </el-form-item>
                    <el-form-item label="通告内容：" prop="content">
<!--                        <el-input-->
<!--                            type="textarea"-->
<!--                            :autosize="{ minRows: 4}"-->
<!--                            placeholder="请输入内容"-->
<!--                            v-model="form.content"-->
<!--                            style="width: 240px"-->
<!--                        >-->
<!--                        </el-input>-->

                        <vue-ueditor-wrap v-model="form.content" :config="myConfig"></vue-ueditor-wrap>
                    </el-form-item>

                </el-form>

                <span slot="footer" class="dialog-footer">
				    <el-button @click="academyValue = false">取 消</el-button>
				    <el-button type="primary" style="margin-left: 16px" @click="saveEdit">确 定</el-button>
				</span>


            </el-dialog>

            <!-- 分页 -->
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page=pageIndex
                    :page-size=10
                    :total=pageTotal
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!---------- 阅读详情 弹出框 ------------>
        <el-dialog :close-on-click-modal='false' :close-on-press-escape='false'
            title='阅读详情'
            :visible.sync="dialogAnnounceStatus"
            width="1000px"
            custom-class="fontSize:16px"
            :before-close="closeDialogAnnounce"
        >

            <div class="search-box">
                <div>
                    <span class="title">姓名/账号：</span>
                    <el-input class="search-input" v-model="announceQueryData.name" placeholder="请输入姓名/账号" clearable @change="getAnnounceData"></el-input>
                </div>
                <div>
                    <span class="title">阅读状态：</span>
                    <el-select class="search-input" clearable v-model="announceQueryData.state" placeholder="发送状态" @change="getAnnounceData"
                               @clear="">
                        <el-option class=""
                                   v-for="item in readStatus"
                                   :key="item.value"
                                   :label="item.label"
                                   :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </div>
                <div>
                    <el-button class="primary-btn" @click="announceReset()">重置</el-button>
                    <el-button type="primary" style="margin-left: 16px" @click="getAnnounceData()">查询</el-button>
                </div>
            </div>

            <div class="table-cls">
                <el-table
                    :data="tableAnnounceData"
                    border
                    class="table"
                    :cell-style="{color:'#666666'}"
                    :header-cell-style="{background:'#eef1f6',color:'#333333',height:'49px',fontWeight:500}"
                >
                    <el-table-column prop="name" align="center" label="姓名"></el-table-column>
                    <el-table-column  prop="account" align="center" label="账号"></el-table-column>
                    <el-table-column prop="state" align="center" label="阅读状态">
                        <template slot-scope="scope">
                            <div :class="scope.row.state==1?'color-blue':'color-red'"> {{ readHash[scope.row.state] }} </div>

                        </template>
                    </el-table-column>
                    <el-table-column  prop="readTime" align="center" label="阅读时间"></el-table-column>
                </el-table>
                <!-- 分页 -->
                <div class="pagination">
                    <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :current-page=announceQueryData.pageIndex
                        :page-size=10
                        :total=announceQueryData.pageTotal
                        @current-change="handleAnnouncePageChange"
                    ></el-pagination>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { isBlank, htmlDecode, htmlEncode } from '../../utils/util';
import moment from 'moment';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { container, QuillWatch } from 'quill-image-extend-module';
import {  quillEditor } from 'vue-quill-editor';
import { Quill } from 'quill'

export default {
    components: { quillEditor },
    data() {
        return {
            // 分页
            pageIndex: 1,
            pageSize: 10,
            pageTotal: 0,
            tableData: [],
            type: 1,
            state: '',
            // 下拉选项 范围 专业 站点 发送状态
            announce_type: [],
            career: [],
            site: [],
            announce_state: [],
            //显示 范围 专业 站点
            range: [],
            job: [],
            website: [],
            send: [],
            announce: '',//无用
            datapost: '',//编辑还是增加
            // 弹出开关
            academyValue: false,
            form: {},

            rules: {
                type: [{
                    required: true,
                    message: '必须选择',
                    trigger: 'blur'
                }],
                title: [{
                    required: true,
                    message: '标题最多为32位',
                    max: 32,
                    trigger: 'blur'
                }],
                content: [{
                    required: true,
                    message: '内容不能为空',
                    min: 1,
                    trigger: 'blur'
                }]
            },
            rules1: {
                type: [{
                    required: true,
                    message: '必须选择',
                    trigger: 'blur'
                }],
                title: [{
                    required: true,
                    message: '标题最多为32位',
                    max: 32,
                    trigger: 'blur'
                }],
                content: [{
                    required: true,
                    message: '内容不能为空',
                    min: 1,
                    trigger: 'blur'
                }],
                station_id: [{
                    required: true,
                    message: '函授站点不能为空',
                    trigger: 'blur'
                }]
            },
            rules2: {
                type: [{
                    required: true,
                    message: '必须选择',
                    trigger: 'blur'
                }],
                title: [{
                    required: true,
                    message: '标题最多为32位',
                    max: 32,
                    trigger: 'blur'
                }],

                // major_id:[{}],
                grade: [{
                    required: true,
                    message: '请选择日期',
                    trigger: 'blur'
                }]
            },
            //控制弹出选项
            // scope:'',
            // 通告内容 标题
            // textarea1:'',
            // textarea2:'',
            //是否显示
            range1: false,
            range2: false,
            //年级
            // 弹出框 专业和站点的绑定值
            formdata: {},
            orgList: [],
            orgHash: [],
            accountOrg: 0,
            dialogAnnounceStatus:false,
            announceQueryData:{
                'id':'',
                'name':'',
                'state':'',
                'pageIndex':1,
                'pageTotal':0,
            },
            tableAnnounceData:[],
            readStatus:[
                {
                    value: '0',
                    label: '未查看'
                }, {
                    value: '1',
                    label: '已查看'
                },
            ],
            readHash:[
                '未查看',
                '已查看'
            ],
            myConfig: {
                // 编辑器不自动被内容撑高
                autoHeightEnabled: false,
                // 初始容器高度
                initialFrameHeight: 450,
                // 初始容器宽度
                initialFrameWidth: '100%',
                // 这里的serverUrl，UEDITOR_HOME_URL用到的值就是在环境配置文件中统一设置的
                serverUrl: process.env.VUE_APP_UEDITOR_SERVER_URL,
                // serverUrl: "http://localhost:80/ueditor",
                UEDITOR_HOME_URL: process.env.VUE_APP_UEDITOR_HOME_URL
            },
        };
    },
    created() {
        this.accountOrg = localStorage.getItem('org');
        this.getTblInfo();
        this.getData();
        this.getTransition();
        this.getOption();
    },
    mounted() {

    },
    methods: {
        test(data) {
            console.log('1111111111111111111111', data);
        },
        getOption() {
            let data = [['id', 'name', 'station_base_t'], ['id', 'major_code,name', 'major_base_t'], ['id', 'name', 'major_base_t']];
            this.$post(
                this.BASEURL + '/assets/table/info', {
                    state: 1,
                    tbl_list: data
                }).then((res) => {
                if (res.code === 200) {
                    //专业
                    this.career = res.data[1][0];
                    this.job = res.data[2][1];
                    //站点
                    this.site = res.data[0][0];
                    this.website = res.data[0][1];

                } else {
                    console.log(res.error);
                }
            });
        },
        getData() {
            this.$get(this.BASEURL + '/announce/management?page=' + this.pageIndex + '&type=' + this.type + '&state=' + this.state).then((res) => {
                if (res.code === 200) {
                    this.tableData = res.data.map(function(item, i, list) {
                        return {
                            'id': list[i].id,
                            send_time: moment(list[i].send_time).format('YYYY-MM-DD HH:mm'),
                            type: list[i].type,
                            title: list[i].title,
                            content: list[i].content,
                            major_id: list[i].major_id,
                            grade: list[i].grade,
                            station_id: list[i].station_id,
                            send_user: list[i].send_user,
                            state: list[i].state,
                            org: list[i].org
                        };
                    });

                    console.log(this.tableData.send_time);
                    this.pageTotal = res.total;
                    console.log('tableData', res.data);
                } else {
                    console.log(res.error);
                }
            });
        },

        getAnnounceData() {
            this.$get(this.BASEURL + '/announce/read/detail?page=' + this.announceQueryData.pageIndex + '&id=' + this.announceQueryData.id + '&name=' + this.announceQueryData.name + '&state=' + this.announceQueryData.state).then((res) => {
                if (res.code === 200) {
                    this.tableAnnounceData = res.data
                    this.announceQueryData.pageTotal = res.total;

                    // this.tableAnnounceData = res.data.map(function(item, i, list) {
                    //     return {
                    //         'id': list[i].id,
                    //         send_time: moment(list[i].send_time).format('YYYY-MM-DD HH:mm'),
                    //         type: list[i].type,
                    //         title: list[i].title,
                    //         content: list[i].content,
                    //         major_id: list[i].major_id,
                    //         grade: list[i].grade,
                    //         station_id: list[i].station_id,
                    //         send_user: list[i].send_user,
                    //         state: list[i].state,
                    //         org: list[i].org
                    //     };
                    // });

                    // this.pageTotal = res.total;
                    // console.log('tableData', res.data);
                } else {
                    console.log(res.error);
                }
            });
        },

        announceReset(){
            this.announceQueryData.state = ''
            this.announceQueryData.name = ''
            this.getAnnounceData();
        },
        getTblInfo() {
            this.$post(this.BASEURL + '/assets/table/info', {
                tbl_list: [['org', 'org_name', 'academy_base_t']],
                state: 0
            }).then((res) => {
                if (res.code === 200) {
                    console.log('res.reeres.reeres.reeres.reeres.reeres.ree', res);
                    this.orgList = res.data[0][0];
                    this.orgHash = res.data[0][1];
                } else {
                    console.log(res.error);
                }
            });
        },
        // 搜索
        handleSearch() {
        },
        reset() {
            this.state = '';
            this.getData();
        },
        //发布通告按钮
        handleAdd() {
            this.academyValue = true;
            this.form = {
                type: 1,
                title: '',
                content: '',
                major_id: '',
                grade: '',
                station_id: '',
                id:'',
            };
            this.range1 = true;
            this.range2 = false;
            this.datapost = 'add';
            console.log(this.form);
        },
        //弹出框 下拉选项事件
        issueInfo() {
            console.log(this.form);
            if (this.form.type == 1) {
                this.range1 = true;
                this.range2 = false;
            } else if (this.form.type == 2) {
                this.range2 = true;
                this.range1 = false;
            } else {
                this.range1 = false;
                this.range2 = false;
            }
        },
        noscope() {
            this.range1 = false;
            this.range2 = false;
        },
        // 保存编辑
        saveEdit() {
            //判断是编辑还是新增
            let is_valid = true;
            this.$refs['form'].validate((valid) => {
                console.log(is_valid)
                if (valid) {
                } else {
                    is_valid = false;
                }
            });

            if (this.form.type == 1) {
                this.formdata = {
                    station_id: this.form.station_id,
                    type: this.form.type,
                    title: this.form.title,
                    content: htmlDecode(this.form.content.trim())
                };
            } else if (this.form.type == 2) {
                if (isBlank(this.form.major_id)) {
                    this.formdata = {
                        grade: this.form.grade,
                        type: this.form.type,
                        title: this.form.title,
                        content: htmlDecode(this.form.content.trim())
                    };
                } else {
                    this.formdata = {
                        major_id: this.form.major_id,
                        grade: this.form.grade,
                        type: this.form.type,
                        title: this.form.title,
                        content: htmlDecode(this.form.content.trim())
                    };
                }
            } else {
                this.formdata = {
                    type: this.form.type,
                    title: this.form.title,
                    content: htmlDecode(this.form.content.trim())
                };
            }
            if (is_valid === false) {
                this.$message.error('信息不符合规定，请按照提示重新填写。');
                return;
            }
            if(this.datapost == 'add'){
                //增加
                this.$post(
                    this.BASEURL + '/announce/management',
                    this.formdata
                ).then((res) => {
                    if (res.code === 200) {
                        this.CloseInfo();
                        this.$message.success(`发送成功！`);
                        this.getData();
                    } else {
                        this.$message.error(res.error);
                    }
                });
            }else{
                //修改

                this.formdata['id'] = this.form.id
                let data = {'fordata': this.formdata}

                this.$put(
                    this.BASEURL + '/announce/management',
                    data
                ).then((res) => {
                    if (res.code === 200) {
                        this.CloseInfo();
                        this.$message.success(res.msg);
                        this.getData();
                    } else {
                        this.$message.error(res.error);
                    }
                });
            }



        },
        handleEdit(index,row){
            this.academyValue = true;

            this.form = {
                id: row.id,
                type: row.type,
                title: row.title,
                content: row.content,
                major_id: row.major_id,
                grade: row.grade,
                station_id: row.station_id
            };
            if (row.type == 1) {
                this.range1 = true;
                this.range2 = false;
            } else if (row.type == 2) {
                this.range2 = true;
                this.range1 = false;
            } else {
                this.range1 = false;
                this.range2 = false;
            }
            this.datapost = 'edit';
            console.log(this.form);
        },
        //转换值
        getTransition() {
            let data = [
                'announce_type',
                'announce_state'
            ];
            this.$post(
                this.BASEURL + '/assets/transition/GET', {
                    'key_list': data
                }).then((res) => {
                if (res.code === 200) {
                    console.log('ww', res);
                    //范围
                    this.announce_type = res.data.announce_type[0];
                    this.range = res.data.announce_type[1];
                    console.log('this.range', this.range);
                    //发送状态
                    this.announce_state = res.data.announce_state[0];
                    this.send = res.data.announce_state[1];
                } else {
                    console.log(res.error);
                }
            });
        },
        // 阅读详情 按钮
        handleAnnounce(index,row) {
            this.announceQueryData.id = row.id
            this.getAnnounceData()
            this.dialogAnnounceStatus = true
        },
        // 删除按钮
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 删除请求
                console.log(row);
                this.deleteAcademy(row.id);
            }).catch(() => {
            });
        },
        // 删除请求
        deleteAcademy(id) {
            this.$del(
                this.BASEURL + '/announce/management?id=' + id).then((res) => {
                if (res.code === 200) {
                    this.$message.success('删除成功！');
                    this.getData();
                } else {
                    this.$message.error(res.error);
                }
            });
        },
        // 分页导航
        handlePageChange(val) {
            this.pageIndex = val;
            this.getData();
        },
        handleAnnouncePageChange(val) {
            this.announceQueryData.pageIndex = val;
            this.getAnnounceData()
        },
        //弹出框开关
        CloseInfo() {
            this.academyValue = false;
        },

        closeDialogAnnounce(){
            this.dialogAnnounceStatus = false;
        },
        // 获取七牛云token
        getQiniuToken() {
            this.$get(this.BASEURL + `/assets/qiniupng/token/GET`).then((res) => {
                if (res.code == 200) {
                    this.token = res.token;
                    this.key = res.key;
                }
            });
        },
    }

};
</script>

<style lang="scss" scoped>
.body {
    button {
        padding: 8px 15px;
        font-size: 14px;
    }
}

.search-input {
    width: 240px;
}

.search-box {
    background-color: #ffffff;
    display: flex;
    align-items: center;
    /*justify-content: space-between;*/
    padding: 28px 30px;
    margin-top: $distance;
    margin-bottom: $distance;
    border-radius: $radius;

    .search-input {
        width: 240px;
        margin-right: 16px;
    }
    .margin-right-0{
        margin-right: 0;
    }

    .title {
        font-size: $title-size;
        line-height: 15px;
        color: $title-color;
    }
}

.primary-btn {
    border-color: #409EFF;
    color: #409EFF;
}

.handle-box {
    margin-bottom: 20px;
    text-align: right;
    margin-right: 20px;
    display: flex;
    justify-content: space-between;

    .search {
        display: flex;
    }
}

/* 表单 */
.table-cls {
    text-align: center;
    margin-top: 30px;
    width: 100%;
}

.table {
    width: 100%;
    font-size: 14px;
}
</style>
